export default featuresRun

/** @ngInject */
function featuresRun(featuresService, $rootScope) {
    $rootScope.$on('$stateChangeStart', (event, next, current) => {
        featuresService.reset()
        featuresService.getFeaturesPromise().then((features) => {
            $rootScope.dataFeature = features
        })
    })
}



// WEBPACK FOOTER //
// ./src/config/features.js